import { isExpired } from 'react-jwt';

// Función para obtener el token del localStorage
function getToken() {
    return localStorage.getItem('token');
  }
const getRefreshToken = () => localStorage.getItem('refreshToken');
const setTokens = (accessToken, refreshToken) => {
  localStorage.setItem('token', accessToken);
  localStorage.setItem('refreshToken', refreshToken);
};
const Url = process.env.REACT_APP_URL_DIR
  
  // Función de envoltura para fetch
  function fetchWithAuth(url, options = {}) {
    const token = getToken();
    if(token && isExpired(token)){
      const refreshToken = getRefreshToken();
      if(refreshToken){
  //      fetch('http://localhost:3001/cliente').then((res) => res.json(),console.log('busco datos'))
    //    fetch(`${url}?nombre=${nombre}`,
        fetch(`${Url}Refresh`,
          {
             method: "POST",
             // body: JSON.stringify(newPost),
             headers: {
                "Authorization": `Bearer ${refreshToken}`,
                "Content-Type": "application/json",
             },
          })
          .then(response => response.json())
          .then(data => setTokens(data.token,refreshToken))
          .catch(error => () => {
            console.error('No se pudo refrescar el token', error)
          // Redirigir al login si el refresh token también ha expirado
            window.location.href = '/login'});
      }else{
        window.location.href = '/login'
      }
    }

    const headers = {
      ...options.headers,
      'Authorization': `Bearer ${token}`
    };
  
    const newOptions = {
      ...options,
      headers
    };
  
    return fetch(url, newOptions);
  }

  export { fetchWithAuth };